module.exports = __webpack_public_path__ + "img/user.581dce66.png";